export default __webpack_public_path__ + "static/media/Plus Icon.d8be681b.svg";